import { TConversationNormalized } from "src/types/entities/conversation"
import { TRepresentative } from "src/types/entities/representative"
import { BasicTopicInfoType, ChannelTypeEnum, Contact, Conversation } from "src/types/graphql/autogenerated"

export const getContactFromConversation = (contactData): Contact => {
    return {
        __typename: 'Contact',
        id: contactData?.id || '',
        contactId: contactData?.contactId || '',
        externalId: contactData?.externalId || '',
        firstName: contactData?.contact?.firstName || '',
        middleName: contactData?.contact?.middleName || '',
        lastName: contactData?.contact?.lastName || '',
        businessName: contactData?.contact?.businessName || '',
        locale: contactData?.locale || 'en_US',
        phoneNumber: {
            number: contactData?.inboundAddress || ''
        },
        external: {
            externalId: contactData?.externalId || '',
        },
        capabilities: [contactData?.channel ? contactData?.channel : ChannelTypeEnum.Sms],
        address: {
            streetNumber: contactData?.contact?.street_num || '',
            streetName: contactData?.contact?.street_name || '',
            city: contactData?.contact?.locality || '',
            postalCode: contactData?.contact?.zip_code ? contactData?.contact?.zip_code : contactData?.contact?.postal_code ? contactData?.contact?.postal_code : '',
            province: contactData?.contact?.administrative_area_4 || '',
            country: contactData?.contact?.country_iso2 || ''
        }
    }
}

export const getTopicsFromConversation = (topicData: { id: string, speaker_id: string }[]): BasicTopicInfoType => {
    const uniqueTopicIds = []
    const uniqueTopics: BasicTopicInfoType[]  = []

    topicData?.forEach(topic => {
        if(!uniqueTopicIds.includes(topic.id)) {
            uniqueTopics.push({id: topic.id})
        }
    })

    return uniqueTopics[0];
}

export const getUniqueTopicIdsFromConversation = (topicData: { id: string, speaker_id: string }[]): string[] => {
    const uniqueTopicIds = []

    topicData?.forEach(topic => {
        if(!uniqueTopicIds.includes(topic.id)) {
            uniqueTopicIds.push(topic.id)
        }
    })

    return uniqueTopicIds
}

export const getRepresentativeId = (repData = [], currentRepId): string => {
    const res = repData.filter(data => {
        return data?.id === currentRepId
    })

    return res[0]?.id
}

export const getRepresentativeUserId = (repData: TRepresentative[], currentRepId: string): string => {
    return repData.find(data => {
        return data?.participantId === currentRepId
    })?.identifier;
}

export const createChannelSid = (convoId: string) => {
    if (convoId) return convoId.replace (/^/,'CH').replace(/-/g, '');
}

export const createUuidFromChannelSid = (channelSid = '') => {
    const rawUuid = channelSid.slice(2);
    if(rawUuid && rawUuid.length === 32) {
        const format = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.trim().split('-');
        let startIndex = 0;
        let lastIndex = format[0].length;
    
        format.forEach((_, i) => {
            const obtainedString = rawUuid.slice(startIndex, lastIndex);
            format[i] = obtainedString
            startIndex = lastIndex;
            if(i !== format.length - 1) lastIndex += format[i+1].length; 
        })
        return format.join('-');
    }
    return null;
}

export const createConversationStructure = (rawConvo: any, representatives: TRepresentative[]) => {
    const conversation: Conversation = {
        __typename: "Conversation",
        id: rawConvo?.id,
        category: rawConvo?.category,
        externalId: rawConvo?.id,
        nextCategories: [],
        contact: getContactFromConversation(rawConvo?.contacts[0]),
        optOutChannels: [],
        hydration: rawConvo.hydration,
        topic: getTopicsFromConversation(rawConvo?.topics),
        topicIds: getUniqueTopicIdsFromConversation(rawConvo?.topics),
        representativePhone: rawConvo?.contacts?.[0]?.outboundAddress,
        representativeId: rawConvo?.primaryRepresentativeId,
        representativeUserId: getRepresentativeUserId(representatives, rawConvo?.primaryRepresentativeId),
        messages: rawConvo?.messages,
        createdAt: rawConvo?.createdAt
    };
    return conversation
}

export const getRepresentativeIdOption = (convo: TConversationNormalized, reps: TRepresentative[]) => {
    return reps.find(rep => rep?.participantId === convo?.representativeId)?.identifier.split("@")[0];
}